import * as ActionTypes from '../actions/actionTypes';
import objectPath from 'object-path';

export default function reduce(state = {}, action) {
    switch (action.type) {
        case ActionTypes.PROCESS_INCOMING_MESSAGE:
            let stateLoc = action.payload.stateLocation;
            let message = action.payload.message;
            let messageArray = state[stateLoc].slice();

            //Remove any processed messages
            let leftOverMessages = messageArray.filter(item => item.message.isProcessed !== true);

            //purge repeated message types
            leftOverMessages = filterRepeatMessageTypes(leftOverMessages, message, action.payload.allowedMultipleWhitelist);

            leftOverMessages.push(message);

            return Object.assign({}, state, { [stateLoc]: leftOverMessages });

        case ActionTypes.SET_IS_PROCESSED:
            return removeProcessed(state, action, action.payload.stateLocation);

        default:
            return state;
    }
}

function removeProcessed(state, action, stateLoc) {
    let updatedState = Object.assign({}, state);

    let receivedMessages = objectPath.get(updatedState, stateLoc);

    let processedMsgIndex = receivedMessages.findIndex(item => item.message.id === action.payload.id);

    receivedMessages[processedMsgIndex].message.isProcessed = true;

    let leftOverMessages = receivedMessages.filter(item => item.message.isProcessed !== true);

    objectPath.set(updatedState, stateLoc, leftOverMessages);

    return updatedState;
}

function filterRepeatMessageTypes(currentMessages, newMessage, allowedMultipleWhitelist) {
    return currentMessages.filter(item =>
        item.message.type.toLowerCase() !== newMessage.message.type.toLowerCase() || isWhitelistedMessageType(newMessage.message.type.toLowerCase(), allowedMultipleWhitelist));
}

function isWhitelistedMessageType(currentType, whitelist) {
    return whitelist && whitelist.length && whitelist.indexOf(currentType) > -1;
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/clientcommunicator/src/reducers/index.js